import { Injectable } from '@angular/core';

import { CanvasElement, CanvasElementId } from '@blaze-runtime/engine-domain';

import {
  CanvasElementComponent,
  CanvasElementController,
} from '../canvas-elements/element-component';
@Injectable({
  providedIn: 'root',
})
export class CanvasElementControllerRegistry {
  private componentRegistry: Record<string, CanvasElementController> = {};

  registerComponent(element: CanvasElement, component: CanvasElementComponent): void {
    this.componentRegistry[element.id] = {
      showSlot: component.showSlot?.bind(component),
      getSelectedIds: component.getSelectedIds?.bind(component),
      getDataSample: component.getDataSample?.bind(component),
    };
  }

  unregisterComponent(component: CanvasElementComponent | undefined): void {
    if (!component) {
      return;
    }
    const entry = Object.entries(this.componentRegistry).find(([, comp]) => comp === component);
    if (entry) {
      const [id] = entry;
      delete this.componentRegistry[id];
    }
  }

  getComponentSync(id: CanvasElementId): CanvasElementController | undefined {
    return this.componentRegistry[id];
  }

  async getComponentAsync(elementId: string): Promise<CanvasElementController | undefined> {
    return new Promise((resolve) => {
      let tryCount = 0;
      const MAX_TRIES = 5;
      let uiComponent = this.getComponentSync(elementId);
      if (uiComponent) {
        resolve(uiComponent);
        return;
      }
      const interval = setInterval(() => {
        uiComponent = this.getComponentSync(elementId);
        if (uiComponent) {
          clearInterval(interval);
          resolve(uiComponent);
        }
        if (tryCount > MAX_TRIES) {
          clearInterval(interval);
          resolve(undefined);
        }
        tryCount++;
      }, 20);
    });
  }
}
